<template>
  <div>
    <v-layout>
      <h3 style="font-weight: normal!important" class="textoAjustado">
        <slot>
        </slot>
      </h3>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'o-small-title'
}
</script>



// WEBPACK FOOTER //
// src/components/generic/titulos/OSmallTitle.vue